import { useState, useEffect, useCallback } from 'react'
import { urlApi } from '../config'
import { getAccessToken } from '../auth'

const PERMISSIONS_KEY = 'adminPermissions'

export default function usePermissions() {
  const [permissions, setPermissions] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(PERMISSIONS_KEY)) || []
    } catch {
      return []
    }
  })
  const [permissionsLoading, setPermissionsLoading] = useState(!permissions.length)

  const fetchPermissions = useCallback(async () => {
    try {
      const token = await getAccessToken()
      const res = await fetch(`${urlApi}/admin/permissions/me`, {
        credentials: 'include',
        headers: {
          ...(typeof token === 'string' && { Authorization: `Bearer ${token}` })
        }
      })

      if (res.ok) {
        const data = await res.json()
        localStorage.setItem(PERMISSIONS_KEY, JSON.stringify(data.permissions))
        setPermissions(data.permissions)
      }
    } catch (error) {
      console.error('Error fetching permissions', error)
    } finally {
      setPermissionsLoading(false)
    }
  }, [])

  useEffect(() => {
    if (window.location.pathname !== '/auth') {
      fetchPermissions()
    }
  }, [fetchPermissions])

  const hasPermission = useCallback(
    (permission) => permissions.includes(permission),
    [permissions]
  )

  const hasAnyPermission = useCallback(
    (...perms) => perms.some((p) => permissions.includes(p)),
    [permissions]
  )

  return { permissions, permissionsLoading, hasPermission, hasAnyPermission, fetchPermissions }
}
